import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useBrowserLanguage } from './useBrowserLanguage';

export type Language = 'ar' | 'en';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const { setLanguage, currentLanguage } = useBrowserLanguage();

  useEffect(() => {
    if (lang === 'ar' || lang === 'en') {
      // Language from URL - save and set
      setLanguage(lang);
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    } else {
      // No language in URL - use from localStorage and sync i18n
      // Use currentLanguage to react to changes when country sets initial language
      const storedLang = currentLanguage;
      if (i18n.language !== storedLang) {
        i18n.changeLanguage(storedLang);
      }
    }
  }, [lang, setLanguage, i18n, currentLanguage]);

  // Use currentLanguage which reacts to changes when country sets initial language
  const defaultLanguage = currentLanguage;
  const language: Language = lang === 'ar' || lang === 'en' ? lang : defaultLanguage;
  const isRTL = language === 'ar';

  return {
    language,
    isRTL,
  };
};
